!(function () {
  "use strict";
  var s,
    e = {
      2449: function (t, n, e) {
        var o = e(5931);
        function i(t, n) {
          o.$G(t, { quantity: n }).then(function (t) {
            u(t);
          });
        }
        function u(t) {
          var n, a;
          window.dispatchEvent(
            new CustomEvent("updateproducts", {
              detail: {
                cart:
                  ((a = []),
                  (n = t).items &&
                    n.items.forEach(function (t) {
                      var n = t.featured_image.url,
                        e = t.final_price / 100;
                      a.push({
                        title: t.product_title,
                        key: t.key,
                        price: e,
                        id: t.variant_id,
                        options: t.options_with_values,
                        image: n,
                        qty: t.quantity,
                        subQty: t.quantity * 3,
                        miniQty: t.quantity * 12,
                        remove: function () {
                          var t = this.key;
                          o.cl(t).then(function (t) {
                            u(t);
                          });
                        },
                        update: function (t) {
                          i(this.key, parseInt(t));
                        },
                        increase: function () {
                          i(this.key, parseInt(this.qty + 1));
                        },
                        decrease: function () {
                          i(this.key, parseInt(this.qty - 1));
                        },
                        one: function () {
                          i(this.key, parseInt("1"));
                        },
                        three: function () {
                          i(this.key, parseInt("3"));
                        },
                        six: function () {
                          i(this.key, parseInt("6"));
                        },
                        twelve: function () {
                          i(this.key, parseInt("12"));
                        },
                        twelveMini: function () {
                          i(this.key, parseInt("12"));
                        },
                        twentyfourMini: function () {
                          i(this.key, parseInt("24"));
                        },
                      });
                    }),
                  { total: n.items_subtotal_price / 100, products: a }),
              },
            })
          ),
            window.dispatchEvent(
              new CustomEvent("updatecartcount", {
                detail: { cartTotal: t.item_count },
              })
            );
        }
        o.y0().then(function (t) {
          u(t);
        });
        var r = e(6486);
        window.productData = function (t) {
          var n = t.preorder ? "Preorder" : "Add to Cart";

          return {
            price: t.variants[0].price / 100,
            comparePrice:
              t.price < t.compare_at_price &&
              1 < t.compare_at_price &&
              t.compare_at_price / 100,
            disabled: !t.variants[0].available,
            button: t.variants[0].available ? n : "Sold Out",
            preoderText: t.preorder ? t.preoderText : null,
            options: t.variants[0].options,
            product: t,
            cartStatus: "",
            formData: { qty: 1, subQty: 4, miniQty: 12, id: t.variants[0].id },
            discountPercent: 0.10,
            discountAmount: 4.00,
            miniDiscountAmount: 0,
            discountedPrice: (
              (t.variants[0].price / 100) *
              (1 - 0.10)
            ).toFixed(2),
            miniDiscountedPrice: (t.variants[0].price / 100).toFixed(2),
            subscriptionDiscount: 0.1,
            qtyChange: function (t) {
              this.formData.qty = t;
            },
            subQtyChange: function (t) {
              this.formData.subQty = t;
            },
            miniQtyChange: function (t) {
              this.formData.miniQty = t;
            },
            remove() {
              var t;
              (t = this.key),
                e.sd(t).then((t) => {
                  r(t);
                });
            },
            increase: function () {
              this.formData.qty++;
            },
            decrease: function () {
              this.formData.qty =
                this.formData.qty - 1 == 0 ? 1 : this.formData.qty - 1;
            },
            one: function () {
              this.formData.subQty = 1;
              this.discountPercent = 0;
              this.discountAmount = 0;
              this.discountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            four: function () {
              this.formData.subQty = 4;
              this.discountPercent = 0.10;
              this.discountAmount = 4.00;
              this.discountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            eight: function () {
              this.formData.subQty = 8;
              this.discountPercent = 0.172;
              this.discountAmount = 13.76;
              this.discountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            twelve: function () {
              this.formData.subQty = 12;
              this.discountPercent = 0.25;
              this.discountAmount = 30.00;
              this.discountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            twelveMini: function () {
              this.formData.miniQty = 12;
              this.discountPercent = 0;
              this.miniDiscountAmount = 0;
              this.miniDiscountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            twentyfourMini: function () {
              this.formData.miniQty = 24;
              this.discountPercent = 0.06667;
              this.miniDiscountAmount = 6;
              this.miniDiscountedPrice = this.getDiscountedPrice(
                this.discountPercent,
                this.subscriptionDiscount
              );
            },
            getSubtotal: function () {
              const unitPrice =
                this.price - this.discountAmount / this.formData.subQty;
              const discountedUnitPrice = Number(
                (unitPrice * (1 - this.subscriptionDiscount)).toFixed(2)
              );
              return (discountedUnitPrice * this.formData.subQty).toFixed(2);
            },
            getSubtotalBtn: function () {
              const unitPrice =
                this.price - this.discountAmount / this.formData.subQty;
              const discountedUnitPrice = Number(
                (unitPrice * (1 - this.subscriptionDiscount)).toFixed(2)
              );
              return (discountedUnitPrice * this.formData.subQty).toFixed(2);
            },
            getSubtotalMini: function () {
              const unitPrice =
                this.price - this.miniDiscountAmount / this.formData.miniQty;
              const discountedUnitPrice = Number(
                (unitPrice * (1 - this.subscriptionDiscount)).toFixed(2)
              );
              return (discountedUnitPrice * this.formData.miniQty).toFixed(2);
            },
            getSubtotalMiniBtn: function () {
              const unitPrice =
                this.price - this.miniDiscountAmount / this.formData.miniQty;
              const discountedUnitPrice = Number(
                (unitPrice * (1 - this.subscriptionDiscount)).toFixed(2)
              );
              return (discountedUnitPrice * this.formData.miniQty).toFixed(2);
            },
            subscribeBtnSubscriptionUpdate: function () {
              var z = document.querySelectorAll(".sls-option-container");
              console.log("add");
              z[1] &&
                z[1].addEventListener("click", () => {
                  this.subscriptionDiscount = 0;
                });
              z[0] &&
                z[0].addEventListener("click", () => {
                  this.subscriptionDiscount = 0.1;
                });
            },
            removeEventHandler: function () {
              var z = document.querySelectorAll(".sls-option-container");
              console.log("remove");
              z[1].removeEventListener("click");
              z[0].removeEventListener("click");
            },
            getUnitPriceFor: function (discountPerBar, retailOnly) {
              var retail = this.price - discountPerBar;
              if (retailOnly || this.subscriptionDiscount === 0) {
                return retail.toFixed(2);
              }
              return (retail * (1 - this.subscriptionDiscount)).toFixed(2);
            },
            getDiscountedPrice: function (discountPercent) {
              return (this.price * (1 - discountPercent)).toFixed(2);
            },
            onSubmit: function (t) {
              var n = this;
              this.button = "Adding to Cart...";
              this.cartStatus = "Adding to cart";
              var e = !(this.disabled = !0);
              try {
                var a,
                  i = new FormData(t.target);
                i.has("qantity") &&
                  ((a = i.get("qantity")), i.set("quantity", a)),
                  fetch(t.target.action, { method: t.target.method, body: i })
                    .then(function () {
                      o.y0().then(function (t) {
                        u(t),
                          (n.button = "Add to Cart"),
                          (n.cartStatus = "Added to cart successfully"),
                          (n.disabled = !1),
                          window.dispatchEvent(
                            new CustomEvent("updatecartstatus", {
                              detail: { cartOpen: !0 },
                            })
                          ),
                          Rebuy.Cart.fetchShopifyCart(function(cart) {
                            Rebuy.SmartCart.setCart(cart);
                            Rebuy.SmartCart.show();
                          });
                      });
                    })
                    .catch(function () {
                      alert("This product is unavailable at the moment"),
                        (n.button = "Unavailable"),
                        (n.cartStatus = "Could not add to cart, product is unavailable"),
                        (n.disabled = !0);
                    }),
                  (e = !0);
              } catch (t) {
                console.log(t);
              }
              var r = { quantity: this.formData.qty };
              !1 === e &&
                o
                  .jX(this.formData.id, r)
                  .then(function () {
                    o.y0().then(function (t) {
                      u(t),
                        (n.button = "Add to Cart"),
                        (n.cartStatus = "Added to cart successfully"),
                        (n.disabled = !1),
                        window.dispatchEvent(
                          new CustomEvent("updatecartstatus", {
                            detail: { cartOpen: !0 },
                          })
                        ),
                        Rebuy.Cart.fetchShopifyCart(function(cart) {
                          Rebuy.SmartCart.setCart(cart);
                          Rebuy.SmartCart.show();
                        });
                    });
                  })
                  .catch(function () {
                    alert("This product is unavailable at the moment"),
                      (n.button = "Unavailable"),
                      (n.cartStatus = "Could not add to cart, product is unavailable"),
                      (n.disabled = !0);
                  });
            },
            update: function (t, n) {
              var e = [];
              this.$el
                .querySelectorAll("[name*=options]")
                .forEach(function (t) {
                  ("SELECT" !== t.tagName && !t.checked) || e.push(t.value);
                });
              var a,
                i =
                  ((i = this.product.variants),
                  (a = e),
                  i.filter(function (t) {
                    return (0, r.isEqual)(t.options, a);
                  })[0] || null);
              i
                ? ((this.formData.id = i.id),
                  (this.price = i.price / 100),
                  i.available
                    ? ((this.disabled = !1), (this.button = "Add to Cart"))
                    : ((this.disabled = !0), (this.button = "Sold Out")))
                : ((this.formData.id = null),
                  (this.disabled = !0),
                  (this.button = "Unavailable"));
            },
          };
        };
      },
    },
    a = {};
  function d(t) {
    var n = a[t];
    if (void 0 !== n) return n.exports;
    n = a[t] = { id: t, loaded: !1, exports: {} };
    return e[t].call(n.exports, n, n.exports, d), (n.loaded = !0), n.exports;
  }
  (d.m = e),
    (s = []),
    (d.O = function (t, n, e, a) {
      if (!n) {
        for (var i = 1 / 0, r = 0; r < s.length; r++) {
          (n = s[r][0]), (e = s[r][1]), (a = s[r][2]);
          for (var o, u = !0, c = 0; c < n.length; c++)
            (!1 & a || a <= i) &&
            Object.keys(d.O).every(function (t) {
              return d.O[t](n[c]);
            })
              ? n.splice(c--, 1)
              : ((u = !1), a < i && (i = a));
          u && (s.splice(r--, 1), void 0 !== (o = e()) && (t = o));
        }
        return t;
      }
      a = a || 0;
      for (var r = s.length; 0 < r && s[r - 1][2] > a; r--) s[r] = s[r - 1];
      s[r] = [n, e, a];
    }),
    (d.d = function (t, n) {
      for (var e in n)
        d.o(n, e) &&
          !d.o(t, e) &&
          Object.defineProperty(t, e, { enumerable: !0, get: n[e] });
    }),
    (d.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (d.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }),
    (d.nmd = function (t) {
      return (t.paths = []), t.children || (t.children = []), t;
    }),
    (d.j = 576),
    (function () {
      var s = { 576: 0 };
      function t(t, n) {
        var e,
          a,
          i,
          r = n[0],
          o = n[1],
          u = n[2],
          c = 0;
        if (
          r.some(function (t) {
            return 0 !== s[t];
          })
        ) {
          for (e in o) d.o(o, e) && (d.m[e] = o[e]);
          u && (i = u(d));
        }
        for (t && t(n); c < r.length; c++)
          (a = r[c]), d.o(s, a) && s[a] && s[a][0](), (s[a] = 0);
        return d.O(i);
      }
      d.O.j = function (t) {
        return 0 === s[t];
      };
      var n = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
    })();
  var t = d.O(void 0, [216], function () {
      return d(2449);
    }),
    t = d.O(t);
})();
